import { useContext } from "react";

import { AlertContext, AlertContextPayload } from "./AlertContext";

export const useAlert = () => useContext(AlertContext) as Required<AlertContextPayload>;
